
import ComponentNavigation from '@/components/ComponentNavigation.vue'
import ComponentFooter from '@/components/ComponentFooter.vue'
export default {
  components: { ComponentNavigation, ComponentFooter },
  layout() {
    return 'default'
  },
  computed: {
    navigation() {
      return this.$store.getters['navigation']
    },
    footer() {
      return this.$store.getters['footer']
    }
  },
  // watch: {
  //   $route(to, from) {
  //     if (to.path !== from.path) {
  //       setTimeout(this.pushPageViewEvent, 300)
  //     }
  //   }
  // },
  created() {},
  beforeMount() {
    let interv = setInterval(() => {
      if (window && window.dataLayer) {
        clearInterval(interv)
        this.pushMetaEvent()
      }
    }, 50)
  },
  mounted() {},
  methods: {}
}
